import React, { useState, useContext, Suspense } from "react";

import { styled } from '@mui/material/styles';

import PropTypes from "prop-types";
import Topbar from "../../../components/Topbar/Topbar";
import Sidebar from "../../../components/Sidebar/Sidebar";
import BillingBanner from "../../../components/BillingBanner/BillingBanner";
import clsx from "clsx";
import { useMediaQuery } from "react-responsive";
import { Oval } from "react-loader-spinner";
import palette from "../../../theme/palette";

const PREFIX = 'MainLayout';

const classes = {
  root: `${PREFIX}-root`,
  shiftContent: `${PREFIX}-shiftContent`,
  content: `${PREFIX}-content`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`&.${classes.root}`]: {
    // paddingTop: 56,
    height: "100%",
    // [theme.breakpoints.up('sm')]: {
    //     paddingTop: 64
    // }
  },

  [`&.${classes.shiftContent}`]: {
    paddingLeft: 240,
  },

  [`& .${classes.content}`]: {
    // height: 'calc(100% - 64px)',
    // width: 'calc(100% - 240px)',
    position: "absolute",
  }
}));

const MainLayout = (props) => {
  const { children } = props;


  const isDesktop = useMediaQuery({ minWidth: 1200 });
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const [openSidebar, setOpenSidebar] = useState(false);

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  const shouldOpenSidebar = isDesktop ? true : openSidebar;

  return (
    <Root
      className={clsx(
        {
          [classes.root]: true,
          [classes.shiftContent]: isDesktop,
        },
        "page"
      )}
    >
      <Sidebar
        onClose={handleSidebarClose}
        open={shouldOpenSidebar}
        variant={isDesktop ? "persistent" : "temporary"}
      />
      <Topbar onSidebarOpen={handleSidebarOpen} />
      <main
        className={classes.content}
        style={{
          width: isDesktop ? "calc(100% - 240px)" : "100%",
          height: isMobile ? "calc(100% - 45px)" : "calc(100% - 64px)",
        }}
      >
        {/* Inside <main>: main is absolute with a fixed height, so a sibling above it would push it off the bottom. */}
        <BillingBanner />
        <Suspense
          fallback={
            <Oval
              color={palette.secondary.main}
              secondaryColor={palette.secondary.light}
              wrapperStyle={{ justifyContent: "center", marginTop: "2rem" }}
            />
          }
        >
          {children}
        </Suspense>
      </main>
    </Root>
  );
};

MainLayout.propTypes = {
  children: PropTypes.node,
};

export default MainLayout;
